/* eslint-disable no-undef */
import { LitElement } from 'lit';

class BrowserWarning extends LitElement {
    static get properties() {
        return {
            enabled: { type: Boolean },
        };
    }

    connectedCallback() {
        super.connectedCallback();

        /**
         * Render broadcast warnings for unsupported browsers
         */
        window.addEventListener('load', () => {
            try {
                // the warning will only be rendered if the page has an element with an id of `broadcast`
                // this is to ensure we render in the correct place, and don't mess with someones layout
                const container =
                    document.querySelector('f-broadcast') ||
                    document.querySelector('#broadcast');
                if (!container) {
                    return;
                }

                // @ts-ignore
                if (!this.enabled) {
                    return;
                }

                // See if the browser supports CSS custom properties https://stackoverflow.com/a/38012166/966362
                if (
                    window.CSS &&
                    window.CSS.supports('color', 'var(--detect)')
                ) {
                    return;
                }

                const storageKey = 'dismissedBrowserVersionWarning';

                // Make sure we don't rerender on the next pages if the user has already dimissed it
                const hasDismissed =
                    window.sessionStorage.getItem(storageKey) === 'true';

                if (hasDismissed) return;

                const broadcastElement = document.createElement('section');
                broadcastElement.className = 'broadcast';
                broadcastElement.setAttribute('aria-label', 'Viktig melding');

                // Message
                const content = document.createElement('div');
                content.className = 'broadcast__content';
                content.innerHTML = `
            <p>Hei! Vi ser at du bruker en eldre nettleser. Det kan derfor hende at FINN ikke fungerer optimalt for deg.</p>
            <p>Fra 1. januar 2021 kan det hende at FINN ikke vil fungere for deg i det hele tatt, ettersom vi ikke lenger kommer til å støtte gamle versjoner av nettlesere.</p>
            <p>Vi anbefaler at du oppdaterer nettleseren eller enheten din til siste versjon. Eller hva med å teste en ny nettleser? Vi har noen forslag 
                <a class="u-display-block u-mt16" href="https://www.google.com/intl/no/chrome/">Google Chrome</a>
                <a class="u-display-block u-mt8" href="https://www.microsoft.com/nb-no/edge">Microsoft Edge</a>
                <a class="u-display-block u-mt8" href="https://www.mozilla.org/nb-NO/firefox/new/">Mozilla Firefox</a>
            </p>
                `;

                broadcastElement.appendChild(content);
                // end Message

                // Button
                const icon = document.createElement('span');
                icon.className = 'icon icon--cross';

                const dismissButtonElement = document.createElement('button');
                dismissButtonElement.className =
                    'button button--pill button--small button--has-icon broadcast__dismiss';
                dismissButtonElement.type = 'button';
                dismissButtonElement.setAttribute('aria-label', 'Lukk');

                const listener = () => {
                    broadcastElement.remove();
                    dismissButtonElement.removeEventListener('click', listener);
                    window.sessionStorage.setItem(storageKey, 'true');
                };

                dismissButtonElement.addEventListener('click', listener);
                dismissButtonElement.appendChild(icon);

                broadcastElement.appendChild(dismissButtonElement);
                // End button

                container.appendChild(broadcastElement);
            } catch (e) {
                // noop
                // eslint-disable-next-line no-console
                console.error(e);
            }
        });
    }
}

customElements.define('browser-warning', BrowserWarning);
